import { useParams } from 'react-router-dom'
import { Typography } from '@mui/material'
import { getCategory, getSubCategory } from '@/content/site'
import { getProduct, productsBySubCategory } from '@/content/products'
import { layout } from '@/theme'
import { Section } from '@/components/ui/Section'
import { Eyebrow } from '@/components/ui/Eyebrow'
import { Breadcrumbs } from '@/components/ui/Breadcrumbs'
import { ProductListing } from '@/components/product/ProductListing'
import { ContactCTA } from '@/components/sections/ContactCTA'
import { Seo } from '@/components/seo/Seo'
import { ProductDetailView } from './ProductDetail'
import { NotFound } from './NotFound'

/**
 * Dispatcher for `/products/:category/:segment`. The segment is either a
 * subcategory (→ product listing) or a product slug (→ product detail).
 * Subcategory and product slugs never collide (tig-mig/stick vs tf###).
 */
export function CategorySegment() {
  const { category, segment } = useParams()
  const cat = getCategory(category)
  if (!cat) return <NotFound />

  // 1) Subcategory listing
  const sub = getSubCategory(category, segment)
  if (sub) {
    const list = productsBySubCategory(cat.slug, sub.slug)
    return (
      <>
        <Seo title={sub.name} path={`/products/${cat.slug}/${sub.slug}`} description={`Browse the True Forge ${sub.name} range.`} />
        <Section sx={{ pb: 0 }}>
          <Breadcrumbs
            items={[
              { label: 'Home', to: '/' },
              { label: 'Products', to: '/products' },
              { label: cat.name, to: `/products/${cat.slug}` },
              { label: sub.name },
            ]}
          />
          <Eyebrow>{cat.name}</Eyebrow>
          <Typography variant="h1" component="h1" sx={{ maxWidth: 940 }}>
            {sub.name}
          </Typography>
          <Typography variant="body1" sx={{ color: 'text.secondary', mt: 3, maxWidth: layout.contentMaxWidth }}>
            Browse the True Forge {sub.name} range — engineered for durability, protection and comfort.
          </Typography>
        </Section>
        <Section sx={{ pt: 0 }}>
          <ProductListing products={list} />
        </Section>
        <ContactCTA />
      </>
    )
  }

  // 2) Product detail
  const product = getProduct(segment)
  if (product && product.category === cat.slug) {
    return <ProductDetailView product={product} />
  }

  return <NotFound />
}
